export const match = (param) => {
  return ['ru', 'en', 'lv'].includes(param);
}
